import { useState } from "react";
import { createSignupRequest } from "../../api/client";
import { buildSignupPayload, describeSignupFailure, JOIN_SUCCESS, PASSWORD_MIN, validateJoin } from "../../joinValidation";
import { JOIN } from "../../portalContent";

const EMPTY = { name: "", username: "", email: "", password: "", confirm: "" };

export default function JoinForm() {
  const [fields, setFields] = useState(EMPTY);
  const [errors, setErrors] = useState({});
  const [state, setState] = useState("idle"); // idle | busy | done
  const [notice, setNotice] = useState("");
  const [show, setShow] = useState(false);

  const set = (key) => (event) => setFields((f) => ({ ...f, [key]: event.target.value }));

  const submit = async (event) => {
    event.preventDefault();
    setNotice("");
    const found = validateJoin(fields);
    setErrors(found);
    if (Object.keys(found).length) return;
    setState("busy");
    const result = await createSignupRequest(buildSignupPayload(fields));
    if (result.ok) {
      setFields(EMPTY);
      setState("done");
    } else {
      setNotice(describeSignupFailure(result.status));
      setState("idle");
    }
  };

  if (state === "done") {
    return (
      <div className="pt-join-card pt-join-done" role="status">
        <span className="pt-join-check" aria-hidden="true" />
        <h3>{JOIN_SUCCESS.title}</h3>
        <p>{JOIN_SUCCESS.body}</p>
      </div>
    );
  }

  const field = (key, label, props = {}) => (
    <div className="pt-field">
      <label htmlFor={`join-${key}`}>{label}</label>
      <input id={`join-${key}`} value={fields[key]} onChange={set(key)} aria-invalid={!!errors[key]} aria-describedby={errors[key] ? `join-${key}-err` : undefined} {...props} />
      {errors[key] && <span id={`join-${key}-err`} className="pt-field-error">{errors[key]}</span>}
    </div>
  );

  return (
    <form className="pt-join-card" onSubmit={submit} noValidate>
      {field("name", "Your name", { autoComplete: "name" })}
      {field("username", "Choose a HACaMS username", { autoComplete: "username", maxLength: 32, autoCapitalize: "none", spellCheck: false })}
      {field("email", "Email", { type: "email", autoComplete: "email", inputMode: "email" })}
      {field("password", "Choose a password", { type: show ? "text" : "password", autoComplete: "new-password" })}
      {field("confirm", "Confirm password", { type: show ? "text" : "password", autoComplete: "new-password" })}
      <div className="pt-join-row">
        <label className="pt-check"><input type="checkbox" checked={show} onChange={(e) => setShow(e.target.checked)} /> Show passwords</label>
        <span className="pt-hint">At least {PASSWORD_MIN} characters</span>
      </div>
      {notice && <div className="pt-join-notice" role="alert">{notice}</div>}
      <button className="pt-btn pt-btn-primary pt-btn-wide" type="submit" disabled={state === "busy"}>
        {state === "busy" ? "Sending…" : JOIN.submit}
      </button>
      <p className="pt-join-note">{JOIN.note} Already a member? <a href="/login">Sign in</a></p>
    </form>
  );
}
